import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ClientSelectionService {
    private forceSelectClientSource = new Subject<string>();

    contragentForced$ = this.forceSelectClientSource.asObservable();

    forceSelectCongtragent(contragentName: string) {
        this.forceSelectClientSource.next(contragentName);
    }
}